import BaseModel from "./BaseModel"

export default class FaceModel extends BaseModel {
    get schema() {
        return {
            type: null,
            position_name: "",
            surname: "",
            name: "",
            patronymic: "",
            inn: "", // 504713563600
            assigned_at: null,
            assigned_to: null,
            day_of_birth: null,
            place_of_birth: "",
            citizenship: "643",
            document_type: "",
            document_seria: "",
            document_number: "",
            document_issued_by: "",
            document_issued_at: null,
            document_subdivision_code: "",
            document_reg_address: "",
            snils: "", // 13849173290
            document_other_data: "",
            is_combined_positions: false,
            // errors
            errorMessages: {
                snils: "",
                inn: "",
                type: ""
            },
        }
    }

    prepareCreate() {
        this.baseClear()

        return this
    }

    prepareUpdate() {
        this.baseClear()

        return this
    }
}
